const SnowEntity = (client) => ({
  create: async (body) => await client.post(`/api/snow/run`, body),
  update: async (id, body) => await client.put(`/api/snow/run/${id}`, body),
})

export default SnowEntity
